<template>
  <div class="white-bg">
    <div class="category-header flex flex-wrap justify-center mx3">
      <div class="col-12 flex justify-center items-center">
        <i class="block menu-item-icon category-header-icon" :class="icon"></i>
        <span class="blue pl2 h3n bold">{{ getReferencelabel(reference).toUpperCase() }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/elements/Icon';
import { getReferencelabel } from '@/mixins/utils';

export default {
  components: { Icon },
  props: {
    reference: {
      type: String,
      default: 'My title'
    },
    icon: {
      type: String,
      default: 'participant'
    }
  },
  setup () {
    return { getReferencelabel };
  }

};
</script>

<style>
.category-header {
  background-color: white;
  border-bottom: 2px solid #00a6c6;
  min-height: 80px;
  height: 80px;
}

.category-header-icon {
  color: #00a6c6;
  font-size: 60px;
}

</style>
